<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">CMS</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
        <el-form-item prop="username">
          <el-input v-model="ruleForm.username" placeholder="请输入用户名">
            <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="ruleForm.password"
            @keyup.enter.native="submitForm('ruleForm')"
          >
            <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" :loading="loading" @click="submitForm('ruleForm')">{{ loading ? '登录中...' : '登录' }}</el-button>
        </div>
        <p class="login-tips">还没有账号？请联系管理员</p>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/getData'

export default {
  data: function() {
    return {
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      showLogin: true,
      loading: false
    }
  },
  created() {
    // 从URL中获取code参数（使用Vue Router，兼容hash模式）
    const code = this.$route.query.code
    if (code) {
      // 如果有code参数，使用授权码登录
      this.loginWithCode(code)
    }
  },
  methods: {
    // 使用授权码自动登录
    async loginWithCode(code) {
      this.loading = true
      try {
        const res = await login({
          username: 'authorization_code',
          password: code,
          source: "cms",
        })
        if (res.code == 200000) {
          localStorage.setItem('ms_username', res.data.username)
          localStorage.setItem('token', 'token ' + res.data.token)
          localStorage.setItem('role', res.data.role)
          this.$router.push('/', () => {
            this.loading = false
          })
        } else if (res.code === 400000) {
          this.loading = false
          this.$message.error(`登录失败, 提示信息: ${res.message}`)
        } else {
          this.loading = false
        }
      } catch (e) {
        this.loading = false
        this.$message.error('请求服务器失败, 联系管理人员')
      }
    },
    submitForm(formName) {
      const submitHandle = async valid => {
        if (!valid) {
          this.$notify.error({
            title: '错误',
            message: '请输入正确的用户名密码',
            offset: 50
          })
          return false
        }

        this.loading = true
        try {
          const res = await login({
            username: this.ruleForm.username,
            password: this.ruleForm.password,
            source: "cms",
          })
          if (res.code == 200000){
              localStorage.setItem('ms_username', res.data.username)
              localStorage.setItem('token', 'token ' + res.data.token)
              localStorage.setItem('role', res.data.role)
              this.$router.push('/', () => {
                this.loading = false
              })
          }else if (res.code===400000){
            this.loading = false
            this.$message.error(`登录失败, 提示信息: ${res.message}`, )
          } else {
            this.loading = false
          }
        } catch (e) {
          this.loading = false
          this.$message.error('请求服务器失败, 联系管理人员')
        }
      }
      this.$refs[formName].validate(submitHandle)
    }
  }
}
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/login-bg.jpg);
  background-size: 100%;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
.ms-content {
  padding: 30px 30px;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>